import { Tag } from "antd"
import { CheckCircleFilled, ClockCircleFilled } from "@ant-design/icons"
import { CloseCircleFilledIcon } from '../../../icon';


function TagCalBom({result}) {
  let elementToRender;

  switch (result) {
    case 'มีแล้ว':
      elementToRender = <Tag icon={<CheckCircleFilled />} color="#347C98"> สร้าง BOM แล้ว </Tag>;
      break;
    case 'ยังไม่มี':
      elementToRender = <Tag icon={<CloseCircleFilledIcon />} color="#ababab"> ยังไม่มี </Tag>;
      break;
   
    default:
      elementToRender = <Tag > Not found </Tag>;
  }
  return <>{elementToRender}</>
}

export default TagCalBom